import { z } from 'zod'

export const billingAccountSummaryReadResponseSchema = z.object({}).passthrough()
export type BillingAccountSummaryReadResponse = z.infer<typeof billingAccountSummaryReadResponseSchema>
